export default "/fonts/fa-solid-900.woff2?41c0f706d8ce93933771be0292757b92";